import { Component } from "@angular/core";
import { Carousel } from "./carousel.model";

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.css']
})
export class CarouselComponent{
    carouselTitle: string = "This is a typical carousel";
    carousels: Carousel[] = [
        new Carousel("pic3","/assets/img/pic3.jpg")
    ];
}